export default __webpack_public_path__ + "static/media/product_02.73e45dc4.png";